import { gql } from '@apollo/client';

export const GET_TAGS = gql`
  {
    listTags {
      id
      name
      permanent
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation updateTag(
    $id: String!
    $name: String!
    $permanent: Boolean
  ) {
    updateTag(
      id: $id
      input: {
        name: $name
        permanent: $permanent
      }
    ) {
      name
      permanent
    }
  }
`;

export const CREATE_TAG = gql`
  mutation createTag(
    $name: String!
    $permanent: Boolean
  ) {
    createTag(
      input: {
        name: $name
        permanent: $permanent
      }
    ) {
      name
      permanent
    }
  }
`;

export const DELETE_TAG = gql`
  mutation deleteTag(
    $id: String!
  ) {
    deleteTag(
      id: $id
    ) {
      name
      permanent
    }
  }
`;
